import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { PrazoProtocoloFiltro, PrazoProtocolo } from '@app/models/prazo-protocolo';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-protocolos-tipo',
  templateUrl: './protocolos-tipo.component.html'
})
export class ProtocolosTipoComponent implements OnInit {
  filtros: PrazoProtocoloFiltro;
  lstProtocolos: Array<PrazoProtocolo>;
  buscando = false;
  @Input() tipoProtocolo: string;
  @Input() tipoAreaId: number;
  titulo = '';
  descricao = '';
  concluido: boolean[] = [];
  mostrarImprimir = false;

  quantidadeProtocolos = 0;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.filtros = {
      DataPesquisa: new Date().toISOString().split('T')[0],
      Tipo: this.tipoProtocolo,
      AreaId: this.tipoAreaId
    };
    this.lstProtocolos = [];

    switch (this.tipoProtocolo) {
      case 'JUDICIAL':
        this.descricao = 'Judiciais';
        this.titulo = 'Relatório de Protocolos (Judiciais)';
        break;
      case 'EXEC':
        this.descricao = 'Execuções Provisórias';
        this.titulo = 'Relatório de Protocolos (Execuções Provisórias)';
        break;
      default:
        break;
    }
  }

  BuscarProtocolos() {
    this.dataRelatorio = new Date;
    this.buscando = true;
    this.relatorioService
      .buscarProtocolados(this.filtros)
      .toPromise()
      .then((data: Array<PrazoProtocolo>) => {
        this.lstProtocolos = [];
        this.concluido = [];
        this.lstProtocolos = data;
        this.lstProtocolos.forEach(() => this.concluido.push(false));
        if (this.lstProtocolos.length === 0) {
          this.toastr.info(`Não foram encontrados protocolos do tipo ${this.descricao} para essa data`);
          this.mostrarImprimir = false;
        } else {
          this.mostrarImprimir = true;
        }
        this.buscando = false;
        this.quantidadeProtocolos = this.lstProtocolos.length;
      }, erro => {
        this.buscando = false;
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("rel-protocolos" + this.tipoProtocolo).innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Tipos de Protocolo", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    parseDateAdicionaMap('Data Protocolos', this.filtros.DataPesquisa);

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
